export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-950/20 via-background-50 to-accent-950/10"></div>
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent-500/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16 max-w-7xl mx-auto w-full">
          <div className="flex-1 w-full lg:max-w-[55%]">
            <span className="inline-flex items-center gap-2 text-xs font-medium text-accent-400 bg-accent-100/15 px-3 py-1.5 rounded-full mb-6 whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              今日黑料最新 · 每日持续爆料
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-50 leading-tight mb-5">
              51黑料网
              <br />
              <span className="text-primary-400">聚合每日最新黑料与八卦爆料</span>
            </h1>

            <p className="text-lg md:text-xl text-primary-300 font-heading mb-8">
              新鲜热辣，每日更新，不错过任何一条黑料
            </p>

            <div className="space-y-4 mb-8">
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed max-w-xl">
                51黑料网今日黑料首页，专注汇聚娱乐圈、网红圈与社交平台最新爆料的黑料每日更新平台。
                无论是今日黑料最新动态还是51黑料今日热点追踪，这里为你提供一站式的黑料新鲜事浏览体验。
                我们以最快的速度、最全的视角，为你整理每日黑料精华，让你轻松掌握黑料入口的每一次重磅更新。
              </p>
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed max-w-xl">
                当前热点覆盖影视综艺幕后、明星私生活爆料、网红翻车实录及社交平台争议事件，
                内容每日滚动刷新，确保你第一时间接收黑料最新消息。
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-100/20 flex items-center justify-center">
                  <i className="ri-timer-flash-line text-accent-400 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-500">更新频率</p>
                  <p className="text-sm font-semibold text-foreground-200">每日滚动刷新</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-100/20 flex items-center justify-center">
                  <i className="ri-radar-line text-primary-400 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-500">覆盖范围</p>
                  <p className="text-sm font-semibold text-foreground-200">全网多平台追踪</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-100/20 flex items-center justify-center">
                  <i className="ri-shield-check-line text-accent-400 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-500">内容安全</p>
                  <p className="text-sm font-semibold text-foreground-200">多方交叉验证</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold rounded-md text-sm transition-all whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-fire-line mr-2"></i>
                查看今日热度榜单
              </a>
              <a
                href="#topics"
                className="w-full sm:w-auto px-8 py-3.5 border border-foreground-400/30 text-foreground-200 hover:text-foreground-50 hover:border-foreground-400/60 rounded-md text-sm transition-all whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-hashtag mr-2"></i>
                浏览热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full lg:max-w-[45%] flex items-center justify-center">
            <div className="relative w-full max-w-md lg:max-w-none aspect-[4/5] lg:aspect-[3/4] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=dark%20atmospheric%20entertainment%20news%20studio%20with%20warm%20amber%20spotlights%2C%20abstract%20geometric%20forms%20representing%20gossip%20spreading%20through%20digital%20networks%2C%20rich%20deep%20blacks%20with%20gold%20accents%2C%20cinematic%20dramatic%20lighting%2C%20modern%20media%20aesthetic%2C%20mysterious%20and%20alluring%20atmosphere%2C%20editorial%20photography%20style%20with%20warm%20undertones&width=1200&height=1000&seq=hero-main&orientation=portrait"
                alt="51黑料网今日黑料首页主视觉 - 娱乐爆料聚合平台"
                className="w-full h-full object-cover rounded-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 via-transparent to-transparent rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}